//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React, { useEffect, useRef, useState } from "react";
import styles from "../assets/styles/InvoicePdf.module.css";
import A_Jain_logo from "../assets/images/A_Jain_logo.png";
import login_bg_top from "../assets/images/login_bg_top.png";
import login_bg_bottom from "../assets/images/login_bg_bottom.png";
import bg_bottom_right from "../assets/images/bg_bottom_right.png";
import sms from "../assets/images/sms.png";
import instagramf from "../assets/images/instagramf.png";
import browse from "../assets/images/browse.png";
import contact from "../assets/images/contact.png";
import Request from "axios";
import { BASE_URL } from "./baseURL";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

function InvoicePdf() {
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//
const componentRef = useRef();
  let temp = JSON.parse(localStorage.getItem("pageData"));
  const [details, setDetails] = useState([]);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Healvick Invoice`,
    onAfterPrint: () => {
      window.close();
    },
  });
//--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//

//---------------------------------------------------------UseEffect to Get Invoice By ID-----------------------------------------------------------------------//

  useEffect(() => {
    Request.get(`${BASE_URL}plans/getInvoice?id=${temp}`)
      .then((res) => {
        if (res?.data?.status === 200) {
          if (res?.data?.data?.length < 1) {
            alert("No invoice generated for you. Please contact the admin");
            window.close();
            localStorage.remove("pageData");
          } else {
            setDetails(res?.data?.data[res?.data?.data?.length - 1]);
            let temp = res?.data?.data[res?.data?.data?.length - 1];
            document.getElementById("invoiceId").innerHTML = temp?.Invoiceno;
            document.getElementById("name").innerHTML = `${temp?.Firstname} ${temp?.Lastname}`;
            document.getElementById("date").innerHTML = moment(temp?.Date).format("YYYY-MM-DD");
            document.getElementById("email").innerHTML = temp?.EmailId;
            document.getElementById("service").innerHTML = temp?.Services;
            document.getElementById("duration").innerHTML = `${temp?.Duration}`;
            document.getElementById("discount").innerHTML = `Discount (if any) : ${temp?.Discount}`;
            document.getElementById("total").innerHTML = `Total: ${temp?.Total} ₹`;
            handlePrint();
          }
        } else {
          alert("Error fetching invoice details");
          window.close();
          localStorage.remove("pageData");
        }
      })
      .catch((err) => {
        console.log("Error fetching invoice details", err);
        // window.close();
      });
  }, []);

  //---------------------------------------------------------UseEffect to Get Invoice By ID-----------------------------------------------------------------------//
  // Calculate values if only Discount (value) and Total are present
  const discountAmount = parseFloat(details?.Discount || 0);
  const totalAmount = parseFloat(details?.Total || 0);
  const actualPrice = discountAmount + totalAmount;
  return (
    <div ref={componentRef} className={styles.pdfBg}>
      <div className={styles.pdfCard}>
        <div className={styles.headerBarPlain}>
          <div className={styles.headerLeft}>
            <img src={A_Jain_logo} className={styles.logosize} alt="logo"></img>
            <div className={styles.phoneNumber}>+91 98671 89080</div>
          </div>
          <div className={styles.headerRight}>
            <div className={styles.invoiceTitlePlain}>INVOICE</div>
            <div className={styles.prominentInvoiceNo}>Invoice No.: <span>{details?.Invoiceno}</span></div>
          </div>
        </div>
        <div className={styles.infoGrid}>
          <div className={styles.infoLabel}>Invoice No.:</div>
          <div className={styles.infoValue}>{details?.Invoiceno}</div>
          <div className={styles.infoLabel}>Date:</div>
          <div className={styles.infoValue}>{moment(details?.Date).format("YYYY-MM-DD")}</div>
          <div className={styles.infoLabel}>Client Name:</div>
          <div className={styles.infoValue}>{details?.Firstname} {details?.Lastname}</div>
          <div className={styles.infoLabel}>Email ID:</div>
          <div className={styles.infoValue}>{details?.EmailId}</div>
        </div>
        <div className={styles.sectionTitle}>Program Details</div>
        <div className={styles.tablediv}>
          <table className={styles.verticalTable}>
            <tbody>
              <tr>
                <td className={styles.labelcell}><b>Program / Services</b></td>
                <td className={styles.valuecell}>{details?.Services}</td>
              </tr>
              <tr>
                <td className={styles.labelcell}><b>Duration</b></td>
                <td className={styles.valuecell}>{details?.Duration}</td>
              </tr>
              <tr>
                <td className={styles.labelcell}><b>Actual Price</b></td>
                <td className={styles.valuecell}>₹ {actualPrice.toFixed(2)}</td>
              </tr>
              <tr>
                <td className={styles.labelcell}><b>Discount Amount</b></td>
                <td className={styles.valuecell}>₹ {discountAmount.toFixed(2)}</td>
              </tr>
              <tr>
                <td className={styles.labelcell + ' ' + styles.finalLabel}><b>Final Amount</b></td>
                <td className={styles.valuecell + ' ' + styles.finalValue}>₹ {totalAmount.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.bottomonefifty}>
          <p className={styles.thered}>* This Program is not Refundable and not Transferrable.</p>
        </div>
      </div>
      <div className={styles.footer}>
        <img src={bg_bottom_right} className={styles.logintop} alt="bg-bottom"></img>
        <div className={styles.footermiddle}>
          <div className={styles.middleflex}>
            <div className={styles.footermiddlein + " " + styles.setmarginleft}>
              <img src={instagramf} className={styles.contactimg} alt="instagram"></img>
              <p className={styles.footermiddlep}>dt.arpita_healvick</p>
            </div>
            <div className={styles.footermiddlein}>
              <img src={sms} className={styles.contactimg} alt="sms"></img>
              <p className={styles.footermiddlep}>dt.arpita@healvick.com</p>
            </div>
            <div className={styles.footermiddlein + " " + styles.setmarginright}>
              <img src={browse} className={styles.contactimg} alt="web"></img>
              <p className={styles.footermiddlep}>www.healvick.com</p>
            </div>
          </div>
        </div>
        <img src={login_bg_bottom} className={styles.logintop} alt="bg-bottom"></img>
      </div>
    </div>
  );
}

export default InvoicePdf;
